<app-button icon="legenda" (clickit)="open.set(!open())" buttonType="text">Legenda</app-button>
@if (open()) {
	<div class="legenda-anchor">
		<div class="legenda-border" (clickOutside)="open.set(false)" [clickOutsideEvents]="'click,touchend'" [delayClickOutsideInit]="true">
			<div class="legenda-options">
				@for (option of options(); track option.value) {
					<div class="option" [class.icon-option]="!!option.icon">
						<div class="legenda" [class]="option.class" [class.icon]="!!option.icon">
							@if (option.icon) {
								<app-icon [name]="option.icon" [rotate]="option.rotate ?? 0" size="inherit"></app-icon>
							}
							@if (style() === "PILL" && option.value === "Geslaagd") {
								<div class="vink">
									<app-icon name="check" size="tiny"></app-icon>
								</div>
							}
						</div>
						<span class="label"> {{ option.value }} </span>
					</div>
				}
			</div>
		</div>
	</div>
}
